import { DeleteOutlined, PoweroffOutlined } from "@ant-design/icons";
import { Button, message, Modal, Table, Tag } from "antd";
import { ColumnType } from "antd/es/table";
import { useEffect, useState } from "react";
import { IikoRole } from "../../features/integration-setting-table/RolesTable/role.type";
import { useLazyGetIikoDepartmentsQuery, useRemoveIikoDepartmentMutation, useUpdateIikoDepartmentMutation } from "../../store/api/departmentApi";

export const IikoDepartmentPage = () => {
    const [getIikoRoles, { data, isLoading }] = useLazyGetIikoDepartmentsQuery();
    const [removeIikoRole] = useRemoveIikoDepartmentMutation();
    const [updateIikoDepartment] = useUpdateIikoDepartmentMutation();
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
    });

    useEffect(() => {
        getIikoRoles({});
    }, []);

    const getColumnSearchProps = (dataIndex: string) => ({
        filterSearch: true,
        onFilter: (value: string, record: any) => record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
        filterMultiple: false,
        filters: data?.data?.map((item: any) => ({
            text: item[dataIndex],
            value: item[dataIndex],
        })) || [],
    });

    const handleDelete = (code: string) => {
        Modal.confirm({
            title: 'Вы уверены, что хотите удалить эту роль?',
            content: 'Это действие нельзя отменить.',
            okText: 'Да',
            okType: 'danger',
            cancelText: 'Нет',
            onOk: async () => {
                try {
                    await removeIikoRole(code).unwrap();
                    message.success('Департамент успешно удалена');
                    getIikoRoles({});
                } catch (error) {
                    message.error('Не удалось удалить департамент');
                }
            },
        });
    };

    const handleUpdate = async (id: string) => {
        Modal.confirm({
            title: 'Вы уверены, что хотите активировать этот департамент?',
            content: 'Департамент будет включен в систему.',
            okText: 'Да',
            okType: 'primary',
            cancelText: 'Нет',
            onOk: async () => {
                try {
                    await updateIikoDepartment(id).unwrap();
                    message.success('Департамент успешно обновлен');
                    getIikoRoles({});
                } catch (error) {
                    message.error('Не удалось обновить департамент');
                }
            },
        });
    };

    const columns = [
        {
            title: 'Название',
            dataIndex: 'name',
            key: 'name',
            ...getColumnSearchProps('name'),
        },
        {
            title: 'Код',
            dataIndex: 'code',
            key: 'code',
            ...getColumnSearchProps('code'),
        },
        {
            title: 'Статус',
            dataIndex: 'enabled',
            key: 'enabled',
            render: (enabled: boolean) => (
                <Tag color={enabled ? 'green' : 'red'}>
                    {enabled ? 'Включен' : 'Отключен'}
                </Tag>
            ),
        },
        {
            title: 'Действия',
            key: 'actions',
            render: (_: any, record: IikoRole) => (
                record.enabled ? (
                    <Button
                        icon={<DeleteOutlined />}
                        danger
                        onClick={() => handleDelete(record.code)}
                    />
                ) : (
                    <Button
                        icon={<PoweroffOutlined />}
                        type="primary"
                        onClick={() => handleUpdate(record.code)}
                    />
                )
            ),
        },
    ];

    const handleTableChange = (newPagination: any) => {
        setPagination(newPagination);
    };

    return (
        <div>
            <h1>Департаменты iiko</h1>
            <Table
                bordered
                columns={columns as ColumnType<IikoRole>[]}
                dataSource={data?.data}
                loading={isLoading}
                pagination={pagination}
                onChange={handleTableChange}
                rowKey="id"
            />
        </div>
    );
};
